/* __next_internal_client_entry_do_not_use__ LeftBanner auto */import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { notLoginHandle } from "@/helpers/blog";
import { useTranslations } from "next-intl";
export const LeftBanner = props => {
  const {
    leftHeaders
  } = props;
  const [activeIndex, setActiveIndex] = useState(-1);
  const t = useTranslations();
  function highlightActiveAnchor(e) {
    let currentSectionId = "";
    let closestDistance = 50;
    let currentActiveAnchor = -1;
    const anchors = document.querySelectorAll("#toc-list a");
    const sections = document.querySelectorAll("#tml h2");
    sections.forEach(section => {
      const sectionTop = section.offsetTop;
      const distance = Math.abs((e === null || e === void 0 ? void 0 : e.target).scrollTop - sectionTop);
      if (distance < closestDistance) {
        closestDistance = distance;
        currentSectionId = section.id;
      }
    });
    anchors.forEach((anchor, index) => {
      if (anchor.getAttribute("href") === "#".concat(currentSectionId)) {
        currentActiveAnchor = index;
      }
    });
    currentActiveAnchor !== -1 && setActiveIndex(currentActiveAnchor);
  }
  useEffect(() => {
    const page = document.getElementById("page");
    page === null || page === void 0 ? void 0 : page.addEventListener("scroll", highlightActiveAnchor);
    return () => {
      page === null || page === void 0 ? void 0 : page.removeEventListener("scroll", highlightActiveAnchor);
    };
  }, []);
  return /*#__PURE__*/_jsx("div", {
    className: "left-banner",
    children: /*#__PURE__*/_jsxs("div", {
      className: "left-banner-content",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "toc",
        id: "toc",
        children: [/*#__PURE__*/_jsx("div", {
          className: "banner-title",
          children: t("Seo_Main_Nav_Quickly")
        }), /*#__PURE__*/_jsx("ul", {
          className: "toc-list",
          id: "toc-list",
          children: leftHeaders.map((item, index) => {
            return /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx("a", {
                className: activeIndex === index ? "active" : "",
                href: "#".concat(item),
                onClick: e => {
                  setActiveIndex(index);
                },
                children: item
              })
            }, index);
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "ceiling-card",
        id: "banner-card",
        onClick: notLoginHandle,
        children: [/*#__PURE__*/_jsx("div", {
          className: "card-text",
          children: /*#__PURE__*/_jsx("p", {
            className: "card-title",
            children: t("Seo_Main_Left_Guide_Text")
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "card-site",
          children: [/*#__PURE__*/_jsx("p", {
            children: t("Seo_Main_Left_Guide_Button")
          }), /*#__PURE__*/_jsx("button", {
            children: /*#__PURE__*/_jsx("svg", {
              className: "icon",
              viewBox: "0 0 1024 1024",
              version: "1.1",
              xmlns: "http://www.w3.org/2000/svg",
              "p-id": "13257",
              children: /*#__PURE__*/_jsx("path", {
                d: "M935.253333 528.213333a42.666667 42.666667 0 0 0-9.386666-46.506666l-297.386667-297.386667a42.496 42.496 0 1 0-60.16 60.16L793.173333 469.333333H128c-23.466667 0-42.666667 19.2-42.666667 42.666667s19.2 42.666667 42.666667 42.666667h665.173333l-224.853333 224.853333a42.496 42.496 0 0 0 30.293333 72.533333c11.093333 0 21.76-4.266667 30.293334-12.373333l297.386666-297.386667c3.84-3.84 6.826667-8.96 8.96-14.08z",
                "p-id": "13258",
                fill: "#ffffff"
              })
            })
          })]
        })]
      })]
    })
  });
};